import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 max-w-4xl mx-auto md:justify-items-center">
          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6">サービス</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/sales" className="text-sm text-gray-400 hover:text-white transition-colors">
                  車両販売
                </Link>
              </li>
              <li>
                <Link to="/purchase" className="text-sm text-gray-400 hover:text-white transition-colors">
                  車買取
                </Link>
              </li>
              <li>
                <Link to="/rental" className="text-sm text-gray-400 hover:text-white transition-colors">
                  レンタカー
                </Link>
              </li>
              <li>
                <Link to="/maintenance" className="text-sm text-gray-400 hover:text-white transition-colors">
                  メンテナンス・修理
                </Link>
              </li>
              <li>
                <Link to="/bodywork-painting" className="text-sm text-gray-400 hover:text-white transition-colors">
                  板金塗装
                </Link>
              </li>
              <li>
                <Link to="/coating" className="text-sm text-gray-400 hover:text-white transition-colors">
                  ボディコート
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-bold mb-6">会社情報</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-white transition-colors">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-white transition-colors">
                  お問い合わせ
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-gray-400 hover:text-white transition-colors">
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-6">お問い合わせ</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-xl flex-shrink-0 mt-0.5"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">電話番号</p>
                  <a href="tel:0427949945" className="text-base font-semibold hover:text-gray-300 transition-colors">
                    042-794-9945
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-xl flex-shrink-0 mt-0.5"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">営業時間</p>
                  <p className="text-sm">10:00〜18:00</p>
                  <p className="text-xs text-gray-500">定休日：月曜日・火曜日</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2025 株式会社KIT KURUMAYA. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
